import classNames from 'classnames';
import styles from './WidgetWrap.module.scss';

interface WidgetWrapProps {
  children: React.ReactNode;
  isBlueBackground?: boolean;
  className?: string;
}

export default function WidgetWrap({
  children,
  isBlueBackground,
  className,
}: WidgetWrapProps) {
  const wrapClassName = classNames(styles.widgetWrap, className, {
    [styles.blueBackground]: isBlueBackground,
  });

  return <div className={wrapClassName}>{children}</div>;
}
